import React from 'react'

export default function ShareLarge(props) {
  return (
    <svg
      width={48}
      height={49}
      viewBox='0 0 48 49'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M7.5 26.4225V38.4225C7.5 40.9085 9.516 42.9225 12 42.9225H36C38.484 42.9225 40.5 40.9085 40.5 38.4225V26.4225'
        stroke='currentColor'
        strokeWidth={3}
      />
      <path d='M24.0001 38.4225V8.42255' stroke='currentColor' strokeWidth={3.10345} />
      <path
        d='M33.5469 18.0904L24.0009 8.54449L14.4529 18.0904'
        stroke='currentColor'
        strokeWidth={3}
      />
    </svg>
  )
}
